import {_doRequest} from 'client/common/utils/api-client/base';
import {ContentTypeArticle} from 'client/articles/components/articles-list/articles-list';

import {GetArticleBySlugResponse, GetArticlesResponse} from '../types';

export const getArticles = async (contentType: ContentTypeArticle): Promise<GetArticlesResponse> => {
    const requestParams = {
        method: 'GET',
        endpoint: `https://${location.host}`,
        retries: [3000],
        url: `/api/articles/tag/${contentType}`
    };

    return _doRequest(requestParams);
};

export const getArticleBySlug = async (slug: string): Promise<GetArticleBySlugResponse> => {
    const requestParams = {
        method: 'GET',
        endpoint: `https://${location.host}`,
        retries: [3000],
        url: `/api/articles/${slug}`
    };

    return _doRequest(requestParams);
};
